import BaseCheckbox from 'components/atoms/baseCheckbox';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

export const SelectAdditionalFields: FC = () => {
  const { t } = useTranslation();
  const { filter, updateFilter } = useFilter();

  return (
    <div className={s['form-group']}>
      <label className={s.bold}>{t('labels.additionalFields')}</label>
      <BaseCheckbox
        label={t('labels.newlyEnrolledPatients')}
        checked={!!filter.newlyEnrolledOnly}
        onChange={(value: boolean) => {
          updateFilter({ newlyEnrolledOnly: value });
        }}
      />
      <BaseCheckbox
        label={t('labels.partials')}
        checked={!!filter.partialsOnly}
        onChange={(value: boolean) => {
          updateFilter({ partialsOnly: value });
        }}
      />
      <BaseCheckbox
        label={t('labels.followUpPatients')}
        checked={!!filter.followUpOnly}
        onChange={(value: boolean) => {
          updateFilter({ followUpOnly: value });
        }}
      />
    </div>
  );
};
